import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ApiConfigService } from 'src/app/shared/services/api-config.service'
import { User } from '@session/models/session'

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  http = inject(HttpClient)
  apiConfig = inject(ApiConfigService)

  login() {
    return this.http.post<User>(`${this.apiConfig.API_AUTH}/login`, {})
  }

  register() {
    return this.http.post<User>(`${this.apiConfig.API_AUTH}/register`, {})
  }

  logOut() {
    return this.http.post(`${this.apiConfig.API_AUTH}/logout`, {})
  }

  validateBeforeRegister(phoneNumber: string) {
    return this.http.get(`${this.apiConfig.API_PHONE_VERIFY}/${phoneNumber}`)
  }
}
